import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GetCookie, send, SERVER_HOST, useFibaMsgBox, useLoading } from '../components'
import axios from 'axios'
import { TOKEN_NAME } from '../constants/token.const'
import { PhotoIcon, XCircleIcon } from '@heroicons/react/24/outline'

const Carousel = () => {

    const [images, setimages] = useState([])
    const { t } = useTranslation()

    const { showLoading } = useLoading()
    const { error, confirm } = useFibaMsgBox()

    const onChangePicture = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        uploadPhoto(e.target.files[0])
    }

    const getPhotoList = async () => {
        const res = await send("pl000021", {}, showLoading);
        if (res.status === 'error') {
            error(res.message)
        } else {
            setimages(res);
        }
    }

    const remove = async (data) => {
        const isconfirm = await confirm(t('confirmdelete'));
        if (isconfirm) {
            const res = await send("pl000022", { id: data.id }, showLoading);
            if (res.status === 'error') {
                error(res.message)
            } else {
                getPhotoList();
            }
        }
    }

    const uploadPhoto = async (data) => {

        const formData = new FormData();
        formData.append("image", data);

        showLoading(true)
        axios.post(SERVER_HOST + "/api/v1/upload/carouselimage", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
            },
            transformRequest: formData => formData,
        }).then((res) => {
            if (res.data.response_code === "RC000000") {
                // setId(res.data.response)
                getPhotoList();
            } else {
                error(t('cannot_upload'))
                console.error(res.data);
            }
        }).catch((err) => {
            error(t('cannot_upload'))
            console.log(err);
        }).finally(() => {
            showLoading(false);
        })
    }

    useEffect(() => {
        getPhotoList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <div className='flex flex-wrap gap-3 mt-2'>
            {images.map((item, index) => <div
                className='k-input k-input-md k-rounded-md k-input-solid'
                style={{ width: '100px', height: '110px' }}
                key={index}
            >

                <div className='flex justify-center fiba-file-input'>
                    <div className='m-auto'>
                        <img
                            src={item.url} alt="upload"
                            className='w-full transition duration-300 ease-in-out hover:scale-105'
                            loading='lazy'
                        />
                    </div>
                </div>
                <div className="absolute top-0 right-0 cursor-pointer" onClick={() => { remove(item) }}>
                    <XCircleIcon className='w-6 h-6 fill-white' />
                </div>
            </div>)}

            <div>
                <input
                    className='sr-only'
                    accept="image/*"
                    id={"fiba-file"}
                    type={'file'}
                    onChange={onChangePicture}
                    name={'file_image'}
                    value={null}
                />
                <label
                    className='cursor-pointer k-input k-input-md k-rounded-md k-input-solid'
                    htmlFor={"fiba-file"}
                    style={{ width: '100px', height: '110px' }}
                >
                    <div className='w-full pt-3 text-center text-gray-500'>
                        <PhotoIcon className='w-12 h-12 mx-auto' />
                        <div className='mt-3 text-xs'>
                            {t('upload_photo')}
                        </div>
                    </div>
                </label>
            </div>

        </div>
    )
}

export default Carousel